
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-registry-connection-point-demo-connection-point"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.en.md?type=demo')
};